import template from "./account-activity-upload-receipt.html"

(function ($, ko) {
    ko.components.register('account-activity-upload-receipt', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new AccountActivityUploadReceipt(params, updateContainerHeight(componentInfo.element));
            }
        }
    });

    function AccountActivityUploadReceipt(params, updateHeight) {
        const self = this;
        const urlParams = {
            page: $.cdh.helper.urlParam('page')
        }
        self.force = urlParams.page === 'AddReceipt';
        
        let model = params.model;

        self.isMobile = params.isMobile || false;
        self.openAddReceiptPopup = ko.observable(self.force);
        self.isAiAdjudicationSettingsLoading = ko.observable(false);

        self.popupModel = {
            isClaim: model.IsFxClaim || model.IsTcClaim || model.IsExpense || model.IsMemberClaim,
            ClaimKey: (model.IsMemberClaim || model.IsExpense) ? model.ClaimKey : model.ClaimId,
            TrnKey: {
                Id: model.TransactionKey,
                SettlementDate: model.SettlementDate,
                SeqNumber: model.SeqNumber
            },
            sourceTranDesc: `Account Activity. ItemId: ${model.ItemId}, Type: ${model.Type}`,
            Receipts: model.Receipts,
            ReceiptsCount: ko.observable(model.Receipts().length),
            Status: model.StatusWithAmount,
            SubmittedStatusText: 'Submitted - Under Review',
            successCallback: function () {
                //function triggered when submitting in upload receipt popup
            }
        };

        self.getAddReceiptMfeUrl = function () {
            const baseUrl = $.cdh.routes.predefined.mfe.addReceipt;
            const query = $.param({
                source: "accountActivity",
                transactionId: model.TransactionKey,
                sequenceNumber: model.SeqNumber,
                settlementDate: model.SettlementDate,
                accountId: model.AccountId || model.FlexAcctKey || ""
            });

            return query ? `${baseUrl}?${query}` : baseUrl;
        };

        self.navigateToAddReceipt = function () {
            window.location.href = self.getAddReceiptMfeUrl();
        };

        self.openLegacyAddReceiptPopup = function () {
            self.openAddReceiptPopup(false);
            self.openAddReceiptPopup(true);
        };

        self.navigateToDefaultAddReceipt = function () {
            self.openLegacyAddReceiptPopup();
        };

        self.onAddReceiptClick = function (data, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (!model.IsCardTransaction) {
                self.openLegacyAddReceiptPopup();
                return false;
            }

            const hasTransactionContext = !!model.TransactionKey &&
                !!model.SettlementDate &&
                (model.SeqNumber !== undefined && model.SeqNumber !== null);

            if (self.isAiAdjudicationSettingsLoading()) {
                return false;
            }

            if (!hasTransactionContext) {
                self.openLegacyAddReceiptPopup();
                return false;
            }

            self.isAiAdjudicationSettingsLoading(true);

            $.ajax({
                url: $.cdh.routes.transactions.getAiAdjudicationSettings({
                    transactionId: model.TransactionKey,
                    sequenceNumber: model.SeqNumber,
                    settlementDate: model.SettlementDate
                }),
                method: 'GET'
            }).done(function (response) {
                let isAiEnabled = response && response.Data && response.Data.IsAIAdjudicationEnabled === true;

                if (isAiEnabled) {
                    self.navigateToAddReceipt();
                    return;
                }

                self.navigateToDefaultAddReceipt();
            }).fail(function () {
                self.navigateToDefaultAddReceipt();
            }).always(function () {
                self.isAiAdjudicationSettingsLoading(false);
            });

            return false;
        };
    }

})(jQuery, ko);
